
export const userHelper = {
    getPublicUserFullName,
    getUserFullName
}

function getPublicUserFullName(user:{ firstname:string, middlename:string, lastname:string}): string {
    return getUserFullName(user.firstname, user.middlename, user.lastname);
}

function getUserFullName(firstname: string, middlename: string, lastname: string): string {
    let fullName = '';
    const append = (add: string) => {
        if(fullName.length > 0 && add.length > 0)
            fullName += ' ' + add;
        else
            fullName += add;

        fullName = fullName.trim();
    };

    append(firstname || '');
    append(middlename || '');
    append(lastname || '');
    return fullName;
}